import * as React from "react"
import * as Utils from "./utils"
import { bodyW } from "../../pptx-configuration/constants"
import * as CommonUtils from "../../utils"
import * as Conf from "../../../configuration"
import * as Model from "../../../../../model"

const PREFIX_COLUMNS_COUNT = 3

export default class PpiProjectTable extends React.Component<Props> {
	private readonly columnValueWidth: number
	private readonly projectData: Utils.ProjectData

	constructor(props: Readonly<Props>) {
		super(props)

		this.columnValueWidth = (bodyW - props.columnLabelWidth)
		/ (2 + props.ppiYears.length)

		this.projectData = Utils.createProjectData(
			props.project,
			props.ppiYears.map<number>(ppiYear => ppiYear.year),
			props.ppi
		)
	}

	render() {
		const columnLabelWidth = this.props.columnLabelWidth
		const id = this.props.id
		const ppiYears = this.props.ppiYears
		const tableConf = this.props.tableConfiguration

		return <table id={id}>
			<thead>
				<tr>
					<th data-pptx-width={columnLabelWidth}
					style={{ ...tableConf.header }}></th>
					<th data-pptx-width={this.columnValueWidth}
					style={{ ...tableConf.header }}>Budget</th>
					<th data-pptx-width={this.columnValueWidth}
					style={{ ...tableConf.header }}>Reste</th>
					{ppiYears.map((ppiYear, yearIndex) =>
					<th data-pptx-width={this.columnValueWidth}
					key={yearIndex}
					style={{ ...tableConf.header }}>{ppiYear.year}</th>)}
				</tr>
			</thead>

			<tbody>
				{this.projectData.map((row, rowIndex) =>
				Utils.isDataGroup(row)
					? this.createDataGroupTableRows(row, ppiYears, rowIndex, tableConf)
					: this.createDataRowTableRow(row, rowIndex, ppiYears, tableConf))}
			</tbody>
		</table>
	}

	private createDataGroupTableRows(
		dataGroup: Utils.DataGroup,
		ppiYears: Model.PpiYear[],
		rowIndex: number,
		tableConf: Conf.TableConfiguration
	): React.ReactNode {
		const tableRows: React.ReactNodeArray = []

		tableRows.push(this.createHeaderTableRow(
			dataGroup.label, ppiYears, rowIndex++, tableConf))

		for (const dataRow of dataGroup.rows) {
		 this.props.enableHideZeroLines
        ? !CommonUtils.isArrayAllValuesZero(dataRow.values) &&
          tableRows.push(
            this.createDataRowTableRow(dataRow, rowIndex++, ppiYears, tableConf)
          )
        : tableRows.push(
            this.createDataRowTableRow(dataRow, rowIndex++, ppiYears, tableConf)
          );
    }

    tableRows.push(this.createTotalTableRow(
		dataGroup.total, ppiYears, rowIndex++, tableConf))
		
		return tableRows
	}

	private createDataRowTableRow(
		row: Utils.DataRow,
		rowIndex: number,
		ppiYears: Model.PpiYear[],
		tableConf: Conf.TableConfiguration
	): React.ReactNode {
		return <tr key={rowIndex}>
			<td style={{ ...tableConf.common }}>{row.label}</td>

			<td style={{ ...tableConf.common, ...tableConf.numeric }}>
				{this.getFormattedValue(row.budget)}
			</td>

			<td style={{ ...tableConf.common, ...tableConf.numeric }}>
				{this.getFormattedValue(row.rest)}
			</td>

			{row.values && row.values.length
				? row.values.map((value, valueIndex) =>
				<td
				key={valueIndex}
				style={{ ...tableConf.common, ...tableConf.numeric }}>
					{this.getFormattedValue(value)}
				</td>)
				: ppiYears.map((ppiYear, yearIndex) =>
				<td key={yearIndex} style={{ ...tableConf.common }}></td>)}
		</tr>
	}

	private createHeaderTableRow(
		label: string,
		ppiYears: Model.PpiYear[],
		index: number,
		tableConf: Conf.TableConfiguration
	): React.ReactNode {
		const colspan = PREFIX_COLUMNS_COUNT + ppiYears.length

		return <tr key={index}>
			<th colSpan={colspan} style={{ ...tableConf.header }}>{label}</th>
		</tr>
	}

	private createTotalTableRow(
		totalRow: Utils.DataRow,
		ppiYears: Model.PpiYear[],
		rowIndex: number,
		tableConf: Conf.TableConfiguration
	): React.ReactNode {
		return <tr key={rowIndex}>
			<th style={{ ...tableConf.subtotal }}>
				{totalRow.label}
			</th>

			<th style={{ ...tableConf.subtotal, ...tableConf.numeric }}>
				{this.getFormattedValue(totalRow.budget)}
			</th>

			<th style={{ ...tableConf.subtotal, ...tableConf.numeric }}>
				{this.getFormattedValue(totalRow.rest)}
			</th>

			{totalRow.values && totalRow.values.length
				? totalRow.values.map((value, valueIndex) =>
				<th key={valueIndex}
				style={{ ...tableConf.subtotal, ...tableConf.numeric }}>
					{this.getFormattedValue(value)}
				</th>)
				: ppiYears.map((ppiYear, yearIndex) =>
				<th key={yearIndex} style={{ ...tableConf.subtotal }}></th>)}
		</tr>
	}

	private getFormattedValue(value: number): React.ReactNode {
		if (undefined === value || null === value) return null
		return CommonUtils.formatCurrency(
			this.props.locale, this.props.currency, value, this.props.roundness)
	}
}

export interface Props {
	columnLabelWidth: number
	currency: string
	id: string
	locale: string
	ppi: Model.Ppi
	ppiYears: Model.PpiYear[]
	project: Model.PpiInvestmentProject
	roundness: Conf.RoundnessValue
	enableHideZeroLines: boolean
	tableConfiguration: Conf.TableConfiguration
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/ppi-generator/ppi-project-table/index.tsx